import { ArrowDownRight } from "lucide-react";

export const HeroSection = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative border-b border-[#0A0A0A] overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1768101225267-c6fc5678c113?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhYnN0cmFjdCUyMGFyY2hpdGVjdHVyZSUyMGZpbmFuY2V8ZW58MHx8fHwxNzc2NjYzMzc1fDA&ixlib=rb-4.1.0&q=85')",
        }}
        aria-hidden
      />
      <div className="grain-overlay" aria-hidden />
      <div className="relative max-w-[1440px] mx-auto px-6 md:px-8 lg:px-12 py-20 md:py-28 lg:py-32">
        <div className="flex items-center gap-3 mb-8 anim-fade-up">
          <span className="w-8 h-px bg-[#0A0A0A]" />
          <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#0A0A0A]">
            PUBLIC REGULATORY DIRECTORY / INDIA
          </span>
        </div>
        <h1
          className="font-display font-black text-4xl sm:text-5xl lg:text-7xl tracking-tighter leading-[0.95] max-w-4xl anim-fade-up"
          style={{ animationDelay: "0.05s" }}
          data-testid="hero-title"
        >
          Every Bank.
          <br />
          Every <span className="text-[#002FA7]">RBI-Registered NBFC.</span>
          <br />
          One searchable index.
        </h1>
        <p
          className="mt-8 max-w-2xl text-base lg:text-lg text-[#4B5563] leading-relaxed anim-fade-up"
          style={{ animationDelay: "0.1s" }}
        >
          <strong className="text-[#0A0A0A]">9,381 institutions</strong> — every scheduled bank
          and every NBFC / ARC / HFC registered with the Reserve Bank of India as of
          Dec 2025. For major institutions we also publish Principal Nodal,
          Grievance, Recovery Head and Legal Head contacts.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-4 anim-fade-up" style={{ animationDelay: "0.15s" }}>
          <a
            href="#directory"
            data-testid="hero-cta-directory"
            className="inline-flex items-center gap-3 bg-[#0A0A0A] text-white px-8 py-4 font-medium hover:bg-[#002FA7] transition-colors"
          >
            Open Directory <ArrowDownRight className="w-4 h-4" />
          </a>
          <a
            href="#stats"
            data-testid="hero-cta-stats"
            className="inline-flex items-center gap-3 border border-[#0A0A0A] text-[#0A0A0A] px-8 py-4 font-medium hover:bg-[#F8F9FA] transition-colors"
          >
            See Coverage
          </a>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 border-t border-l border-[#0A0A0A] max-w-4xl anim-fade-up" style={{ animationDelay: "0.2s" }}>
          {[
            { k: "INSTITUTIONS", v: "9,381" },
            { k: "NBFCs & ARCs", v: "9,222" },
            { k: "BANKS", v: "159" },
            { k: "ACCESS", v: "Public" },
          ].map((b) => (
            <div key={b.k} className="border-r border-b border-[#0A0A0A] p-4">
              <div className="font-mono text-[10px] tracking-[0.2em] text-[#4B5563] mb-1">
                {b.k}
              </div>
              <div className="font-display font-bold text-lg">{b.v}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
